/**
 * custom.js — Tema Quê Tentação
 *
 * CORREÇÕES IMPLEMENTADAS (02/04/2026):
 *
 * PROBLEMA 1 — Parcelamento nunca atualizava ao trocar variante:
 *   ANTES: $(".block-swatch__radio").change() + setTimeout(150) + leitura de texto do DOM
 *   DEPOIS: document.addEventListener('variant:changed', ...) + leitura de variant.price (em centavos)
 *   MOTIVO: O tema limpa o .price-list via innerHTML='' antes de disparar variant:changed,
 *           então qualquer setTimeout era uma corrida contra o DOM. Ler o preço do objeto
 *           variant (disponível no evento) é direto e confiável.
 *
 * PROBLEMA 2 — Seletor .parcelamento não existia no HTML:
 *   ANTES: $('.parcelamento').html(...) — classe inexistente no liquid, código não fazia nada
 *   DEPOIS: '.parcelamento__value' (classe adicionada no snippet product-info.liquid)
 *
 * PROBLEMA 3 — Parcelamento usava preço estático (product.price):
 *   ANTES: {{ product.price | times: 1.2161 ... }} — preço do produto padrão, nunca mudava
 *   DEPOIS: {{ selected_variant.price | times: 1.2161 ... }} + atualização via JS no evento
 *
 * PROBLEMA 4 — .discount__percentage e parcelamento dentro do .price-list:
 *   O tema faz productPrices.innerHTML = '' em _updateProductPrices(), apagando esses elementos.
 *   SOLUÇÃO: Ambos foram movidos para FORA do .price-list no snippet product-info.liquid.
 *
 * PROBLEMA 5 — Código ofuscado decodificado para legibilidade e manutenção.
 *
 * REGRA GERAL: Nenhuma funcionalidade existente foi removida ou quebrada.
 */

// === 1. Utilitário de Formatação Monetária =================================
//
// Usa window.theme.moneyFormat (definido pelo tema em theme.liquid)
// para garantir consistência com o formato já em uso na loja.

function formatarMoeda(centavos) {
  var formato = (window.theme && window.theme.moneyFormat) || 'R$\u00a0{{amount_with_comma_separator}}';

  var valor = (centavos / 100).toFixed(2);
  var partes = valor.split('.');
  var inteira = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  var decimal = partes[1];

  return formato
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, inteira + ',' + decimal)
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, inteira)
    .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g,
      partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + ',' + decimal)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.floor(centavos / 100)))
    .replace(/\{\{\s*amount\s*\}\}/g, (centavos / 100).toFixed(2));
}

// === 2. Parcelamento + Desconto Percentual ==================================
//
// FATOR_JUROS_12X: ajuste este valor para alterar a taxa de juros do parcelamento.
// Exemplo: 1.2161 representa aproximadamente 1,8% a.m. em 12x.

var FATOR_JUROS_12X = 1.2161;

function atualizarParcelamento(variant) {
  if (!variant) return;

  // 2a. Atualiza o valor da parcela no elemento .parcelamento__value
  var parcelamentoValorEl = document.querySelector('.parcelamento__value');
  if (parcelamentoValorEl) {
    var valorParcela = Math.round(variant.price * FATOR_JUROS_12X / 12);
    parcelamentoValorEl.innerHTML = '<b>' + formatarMoeda(valorParcela) + '</b>';
  }

  // 2b. Atualiza e exibe/oculta o badge de desconto percentual
  var discountEl = document.querySelector('.discount__percentage');
  if (discountEl) {
    var temDesconto = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (temDesconto) {
      var pct = Math.round(
        (variant.compare_at_price - variant.price) * 100 / variant.compare_at_price
      );
      var textEl = discountEl.querySelector('.discount__percentage-text');
      if (textEl) {
        textEl.textContent = pct + '%';
      }
      discountEl.style.display = '';
    } else {
      discountEl.style.display = 'none';
    }
  }

  // 2c. Atualiza o label "R$ X de desconto" (classe product-label--on-sale-amount)
  var saleAmountEl = document.querySelector('.product-label--on-sale-amount');
  if (saleAmountEl) {
    var labelListEl = saleAmountEl.closest('.product-meta__label-list');
    var temDesconto2 = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (temDesconto2 && labelListEl) {
      saleAmountEl.textContent =
        formatarMoeda(variant.compare_at_price - variant.price) + ' de desconto';
      labelListEl.style.display = '';
    } else if (labelListEl) {
      labelListEl.style.display = 'none';
    }
  }
}

// Escuta o evento nativo do tema. Ele é disparado em _onVariantChanged(),
// APOS todas as atualizações de DOM de preço feitas pelo tema.
document.addEventListener('variant:changed', function (event) {
  atualizarParcelamento(event.detail.variant);
});

// === 3. Botão Scroll-to-Top (apenas mobile) =================================

if (window.matchMedia('(max-width: 768px)').matches) {
  window.onscroll = function () {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
    var btn = document.getElementById('scrollToTop');
    if (btn) {
      btn.style.display = pageOffset > 1200 ? 'block' : 'none';
    }
  };
}

// === 4. Ocultar links injetados pelo app AliHunter ==========================
// Remove badges/links do app alihunter.io que podem aparecer na vitrine.
// O intervalo encerra sozinho apos ~4 segundos.

(function ocultarLinksAlihunter() {
  var inicio = Date.now();
  var intervalo = setInterval(function () {
    if (Date.now() - inicio > 3845) {
      clearInterval(intervalo);
      return;
    }
    [
      'a[href="https://beta.alihunter.io"]',
      'a[href="https://alihunter.io"]'
    ].forEach(function (seletor) {
      document.querySelectorAll(seletor).forEach(function (el) {
        el.style.display = 'none';
      });
    });
  }, 769);
})();

// === 5. Redirecionamento: /collections/all?sort_by=best-selling =============
// Evita exibir a colecao "all" com filtro best-selling; redireciona para /collections/all.

document.addEventListener('DOMContentLoaded', function () {
  if (document.location.href.indexOf('/collections/all?sort_by=best-selling') !== -1) {
    document.location.href = '/collections/all';
  }
}, false);
